export default "__VITE_ASSET__0525658e__"